module.exports = __webpack_public_path__ + "fonts/Rubik-BlackItalic.8cf69a68.ttf";